import React from "react";

function LoadingGIF() {
  return (
    <>
      <div className="w-full h-full flex justify-center items-center">
        <img src="/loading.gif" alt="" className="w-[20vw]" />
      </div>
    </>
  );
}
export default LoadingGIF;
